import React, { useCallback, useState } from 'react';
import * as Styles from './PrivateSslCertificate.styles';
import {
  Button,
  Checkbox,
  IconData,
  IconLoading,
  Input,
} from 'gatorcomponents';
import useLocale from '@/hooks/useLocale/useLocale';
import { V2Forms } from '@/hooks/supportForms/useSupportForms.types';

export const PrivateSslCertificate = ({
  selectedProduct,
  opening,
  submitForm,
}) => {
  const { ticket: ticketsLocale } = useLocale();
  const {
    privateSslCertificate: privateSslCertificateLocale,
  } = ticketsLocale.forms;
  const [formData, setFormData] = useState({
    domain: '',
    agreed: false,
  });

  const checkForm = useCallback(() => !(!!formData.domain && !!formData.agreed), [formData]);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    const data = {
      locale: ticketsLocale,
      automation: false,
      pid: selectedProduct.pid,
      product: selectedProduct.id,
      subject: privateSslCertificateLocale.subject,
      server_value: selectedProduct.serverhostname,
      domain_value: selectedProduct.domain,
      key: V2Forms.PRIVATE_SSL,
      tags: [
        'whmcs_form_tecnico_certificado_ssl_privado_2',
        selectedProduct.name.toLowerCase().replace(/ /g, '_'),
      ],
      body: `
        • ${privateSslCertificateLocale.body.product(selectedProduct)}
        • ${privateSslCertificateLocale.body.request}
        • ${privateSslCertificateLocale.body.domain(formData.domain)}
        • ${privateSslCertificateLocale.body.agreed(formData.agreed)}
        • ${privateSslCertificateLocale.body.productId(selectedProduct)}
      `,
    };

    submitForm && submitForm(data);
  }, [
    ticketsLocale,
    selectedProduct,
    formData,
    submitForm,
    privateSslCertificateLocale,
  ]);

  const handleChange = useCallback(({ key, value }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  }, [
    formData,
  ]);

  return (
    <Styles.Form onSubmit={e => handleSubmit(e)}>
      <Styles.Info>
        <IconData />
        {privateSslCertificateLocale.info}
      </Styles.Info>

      <Styles.Title>
        {privateSslCertificateLocale.title}
      </Styles.Title>

      <Styles.InputsWrapper>
        <Input
          name="domain"
          placeholder={privateSslCertificateLocale.placeholders.domain}
          label={formData.domain ? privateSslCertificateLocale.placeholders.domain : ''}
          value={formData.domain}
          onChange={e => handleChange({ key: 'domain', value: e.target.value })}
          type="text"
          testId="domain"
        />
        <Styles.InfoText>
          {privateSslCertificateLocale.placeholders.domainInfo}
        </Styles.InfoText>

      </Styles.InputsWrapper>

      <Styles.CheckboxLabel
        htmlFor="#readTerms"
        data-testid="checkReadTerms"
        onClick={() => handleChange({ key: 'agreed', value: !formData.agreed })}
      >
        <Checkbox checked={formData.agreed} id="readTerms" />
        <Styles.Text>
          {privateSslCertificateLocale.placeholders.agreed}
        </Styles.Text>
      </Styles.CheckboxLabel>

      <Styles.ButtonWrapper>
        <Button
          size="large"
          label={opening ? <IconLoading /> : privateSslCertificateLocale.send}
          disabled={checkForm() || opening}
          type="submit"
          testId="submit"
        />
      </Styles.ButtonWrapper>
    </Styles.Form>
  );
};

export default PrivateSslCertificate;
